/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconSubtract/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconSubtract({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconSubtract",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconSubtract.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-237zWS': alignSelf,'--mt-2-237zWS': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-237zWS': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-237zWS': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-237zWS': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-237zWS': opacity,'--w-10-237zWS': typeof width === 'number' ? `${width}px` : width,'--h-11-237zWS': typeof height === 'number' ? `${height}px` : height,'--f-12-237zWS': fill,'--a-7-237zWS': isAnimated ? animation : "none",'--sd-8-237zWS': isAnimated ? strokeDashoffset : 0,'--sd-9-237zWS': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconSubtract.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M12 19a7 7 0 100-14 7 7 0 000 14zm-3-7.75a.75.75 0 000 1.5h6a.75.75 0 000-1.5H9z"
 style={{'--f-12-237zWS': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}